import { render, staticRenderFns } from "./NavigationList.vue?vue&type=template&id=288de066&scoped=true"
import script from "./NavigationList.vue?vue&type=script&lang=js"
export * from "./NavigationList.vue?vue&type=script&lang=js"
import style0 from "./NavigationList.vue?vue&type=style&index=0&id=288de066&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288de066",
  null
  
)

export default component.exports